<div class="list-group position">
  <button type="button" (click)="setOption(1)" [ngClass]="{'active': index==1}" class="list-group-item list-group-item-action">
    Carrito
  </button>
  <button type="button" (click)="setOption(2)" [ngClass]="{'active': index==2}" class="list-group-item list-group-item-action">
    Mis ordenes
  </button>
  <button type="button" (click)="setOption(3)" [ngClass]="{'active': index==3}" class="list-group-item list-group-item-action">
    Historial de compras
    </button>
</div>